"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaKeys = void 0;
const zod_1 = require("zod");
const util_1 = require("../util");
/**
 * Extracts all keys from a Zod schema, flattening nested objects and arrays and converting to zod literals
 * @returns {ZodKeyList} At least 2 zod literals representing keys in the schema, e.g. [z.literal('event.event_id'), z.literal('event.name')]
 */
const schemaKeys = (schema) => (0, util_1.zodKeys)(schema).map(k => zod_1.z.literal(k));
exports.schemaKeys = schemaKeys;
//# sourceMappingURL=util.js.map